<template>
  <layout>
    <div class="row">
      <div class="col" v-if="showResumenFactura">
        <div class="alert alert-warning">
          Por favor, cargá tu factura en este sector para poder realizar el
          envío de tu pedido de Miami a Argentina. <br />
          Resumen de envíos pendientes de recibir facturas:
          <span v-for="tracking in trackings" :key="tracking.id">
            <strong v-if="!tracking.has_factura">
              | {{ tracking.idens }} {{ " | " }}
            </strong>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex">
          <span class="ml-auto">
            <button
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              data-target="#uploadFiles"
            >
              Subir Factura
            </button>
          </span>
        </div>
      </div>
    </div>

    <div class="row mb-1"></div>

    <div class="row">
      <div class="col">
        <!--Table-->
        <table id="tablePreview" class="table table-hover table-responsive-lg">
          <!--Table head-->
          <thead>
            <tr>
              <th class="text-center">#</th>
              <th class="text-center">Id</th>
              <th class="text-center">N° Tracking</th>
              <th class="text-center">Factura</th>
              <th class="text-center">Remitente</th>
              <th class="text-center">Arribo</th>
              <th class="text-center">Carga</th>
            </tr>
          </thead>
          <!--Table head-->
          <!--Table body-->
          <tbody>
            <tr v-for="tracking in trackings" :key="tracking.id">
              <td class="text-center">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    value=""
                    :id="tracking.idens"
                    @click="listIdCheckBox(tracking.idens)"
                  />
                </div>
              </td>
              <td class="text-center">{{ tracking.idens }}</td>
              <td class="">
                Tracking: <span class="small">{{ tracking.nro_traking }}</span>
                <br />
                Guía hija: <span class="small"> {{ tracking.guia_hija }} </span>
              </td>
              <td
                class="text-center"
                v-html="formatFacturaBoolean(tracking.has_factura)"
              ></td>
              <td class="small">{{ tracking.remite }}</td>
              <td class="text-center">
                {{ formatDate(tracking.fecha_arribo) }}
              </td>
              <td class="small">
                Bultos: {{ tracking.cantidad_bultos }} <br />
                Peso: {{ tracking.peso }} {{ tracking.unidad_peso }}
              </td>
            </tr>
          </tbody>
          <!--Table body-->
        </table>
        <!--Table-->
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col">
        <p>
          Si su factura fue enviada por mail y no posee el archivo. Por favor
          reenvie el email a
          <a href="mailto:info@sarexpress.com">
            <strong>info@sarexpress.com</strong>
          </a>
        </p>
      </div>
    </div>

    <!-- <modal
      name="facturas-modal"
      :adaptive="false"
    > -->
    <div
      class="modal fade"
      id="uploadFiles"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-body">
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div class="modal-content" style="background-color: white">
            <div class="container">
              <div class="row">
                <div class="col">
                  <div class="modal-form">
                    <div class="modal-title">
                      <h3>Subir Factura</h3>
                    </div>
                    <div class="form-group">
                      <label for="tracking-id">Número/s de Tracking</label>
                      <input
                        class="form-control"
                        disabled
                        :value="list_IDs_CheckBox ? list_IDs_CheckBox : ''"
                      />
                    </div>

                    <div class="custom-file">
                      <input
                        type="file"
                        ref="file"
                        class="custom-file-input"
                        id="tracking-id"
                        @change="onFileSelected"
                        multiple
                      />
                      <label
                        class="text-left custom-file-label"
                        for="tracking-id"
                        v-text="labelUploadFactura"
                      ></label>
                    </div>
                    <div class="alert alert-success my-3" role="alert" v-if="filesFactura">
                      <div v-for="(file, index) in filesUpload" :key="index">
                        {{ file.name }}
                      </div>
                    </div>
                    <div
                      class="form-group mt-3"
                      v-show="messageErrorUploadFile"
                    >
                      <div id="messageError ">
                        <div class="alert alert-danger" role="alert" v-html="messageErrorUploadFile">
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-row-reverse mt-3">
                      <button
                        type="button"
                        class="btn btn-block btn-primary"
                        :disabled="disableUploadsButton"
                        @click="submitFile()"
                      >
                        Subir Facturas
                      </button>
                    </div>

                    <div class="d-flex flex-row-reverse mt-3">
                      <button
                        class="btn btn-block btn-secondary"
                        data-dismiss="modal"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </modal> -->

    <!--  -->

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    ></div>

    <!--  -->
    <!-- <div class="center-content"><h2>En construcción</h2></div> -->
  </layout>
</template>
<script>
import Layout from "../layout/Layout";
import { mapState, mapActions } from "vuex";
// import Axios from "axios";
import { postApi, API_URL } from "@/service/api";

export default {
  components: {
    Layout,
  },

  data: () => ({
    currentId: null,
    list_IDs_CheckBox: [],
    // fileFactura: "",
    filesFactura: "",
    textLabelUploadFactura: "Seleccione su Factura",
    textErrorUploadFile: "",
    heightModal: "800px",
    extensionActivated: ["doc", "docx", "pdf", "png", "jpeg", "jpg"],
  }),

  mounted() {
    this.initialize();
  },

  computed: {
    ...mapState(["trackings"]),
    disableUploadsButton() {
      return this.list_IDs_CheckBox.length === 0;
    },
    labelUploadFactura() {
      return this.textLabelUploadFactura;
    },
    messageErrorUploadFile() {
      return this.textErrorUploadFile;
    },
    computedHeightModal() {
      return this.heightModal;
    },
    showResumenFactura() {
      const hasFacturaList = this.trackings.filter(
        (tracking) => !tracking.has_factura
      );
      return hasFacturaList.length == 0 ? false : true;
    },
    filesUpload() {
      return this.filesFactura;
    },
  },

  methods: {
    ...mapActions(["listTrackings"]),
    openFacturasModal(id) {
      this.currentId = this.trackings.findIndex(
        (tracking) => tracking.id === id
      );
      this.$modal.show("facturas-modal");
    },
    closeModal() {
      this.textErrorUploadFile = null;
      // this.fileFactura = null;
      this.filesFactura = null;
      this.$modal.hide("facturas-modal");
    },

    onFileSelected() {
      this.filesFactura = this.$refs.file.files;
      const filesCorrect = []
      this.textErrorUploadFile = "";

      this.filesFactura.forEach(fileFactura => {
        const parserFile = fileFactura.name.split(".");
        const extension = parserFile[parserFile.length - 1];   

        if (!this.extensionActivated.includes(extension)) {
          this.textErrorUploadFile += `La extension del archivo "${fileFactura.name}" debe ser algunas de las siguientes: ${this.extensionActivated.join(
            " - ")} <br>`;
        } else {
          // console.log('name', fileFactura.name)
          // fileFactura.name = `pabmac.${extension}`
          filesCorrect.push(fileFactura);
        }
      })
      this.filesFactura = filesCorrect;
    },

    async submitFile() {

      // Inicializamos formData
      let formData = new FormData();

      // Las facturas correctas están en this.filesFactura
      const po_box = this.$store.state.user.po_box;
      formData.append("po_box", po_box);
      formData.append("nro_traking", this.list_IDs_CheckBox);
      this.filesFactura.forEach((fileFactura) => {
        formData.append(`fileFactura`, fileFactura);
      })


      const res = {
        success: false,
      };

      try {
        const response = await postApi(API_URL + "/api/v01/tracking/uploads/", formData)
        console.log("SUCCESS!!", response.statusText);
        res.success = true;
        res.status = 201;

      } catch (error) {
        console.log("FAILURE!!", error.response.data);
        res.success = false;
        res.response = error.response;
        this.textErrorUploadFile = error.response.data;
      }


      if (res.success && res.status === 201) {
        this.filesFactura = "";
        this.textLabelUploadFactura = "Seleccione su Factura";
        this.initialize();
        this.closeModal();
      }
    },

    initialize() {
      return this.listTrackings();
    },

    formatDate(date) {
      const newDate = date.split("-");
      return `${newDate[2]}-${newDate[1]}-${newDate[0]}`;
    },
    formatFacturaBoolean(boolean) {
      if (boolean) {
        return `<span class="text-success"> <i class="far fa-check-circle"></i></span>`;
      }
      if (!boolean) {
        return `<span class="text-danger"> <i class="far fa-times-circle"></i></span>`;
      }
    },
    listIdCheckBox(id) {
      if (!this.list_IDs_CheckBox.includes(id)) {
        this.list_IDs_CheckBox.push(id);
      } else {
        this.list_IDs_CheckBox = this.list_IDs_CheckBox.filter(
          (value) => value !== id
        );
      }
      return;
    },
  },
};
</script>
<style scoped>
.modal-content {
  background-color: white;
  background-image: None;
}

.modal-form {
  padding: 2rem;
}
/* .vm--modal {
  height: 300px !important;
} */
.center-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>